import './App.css';
import { useEffect } from 'react';
import Photo from './components/Photo';
import Footer from './components/Footer';
import Buttons from "./components/Buttons";
import About from "./components/About";

function App() {
        useEffect(() => {
            document.title = 'About Trix Mostert';
        }, []);
  return (
      <div className="App">
          <div className="ctn">
              <Photo/>
              <div className='ctn-mid-section'>
                  <About/>
                  <Buttons/>
                  <Footer/>
              </div>
          </div>
      </div>
  );
}

export default App;
